import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CrmObjectAssociationFormField, FormFieldAssociation } from '../interface';
import { CrmAssociationFormFieldComponent } from '../association-form-field.component';

@Component({
  selector: 'crm-company-association-form-field',
  templateUrl: './company-association.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, CrmAssociationFormFieldComponent],
})
export class CrmCompanyAssociationFormFieldComponent extends CrmObjectAssociationFormField {
  @Input({ required: true }) set associations(value: FormFieldAssociation[]) {
    this.setAssociations(value);
  }
  @Input() fixedId: string | null = null;
  @Input({ transform: coerceBooleanProperty }) mobile: boolean | null = null;
  @Input() placeholder = '';

  @Output() associationsChange = new EventEmitter<FormFieldAssociation[]>();

  protected readonly crmObjectType = 'Company';

  protected handleAdd(association: FormFieldAssociation): void {
    const associations = this.associationsList();
    if (!associations.find((a) => a.crmObjectId === association.crmObjectId)) {
      const newAssociations = [...associations, association];
      this.associationsList.set(newAssociations);
      this.associationsChange.emit(newAssociations);
    }
  }

  protected handleRemove(association: FormFieldAssociation): void {
    const associations = this.associationsList().filter((a) => a.crmObjectId !== association.crmObjectId);
    this.associationsList.set(associations);
    this.associationsChange.emit(associations);
  }

  protected handleSearchTermChange(searchTerm?: unknown): void {
    this.updateSearchTerm(searchTerm);
  }
}
